import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const PipelineProspectsModelSchema = z
  .object({
    id: z.string(),
    stage: z.string().nullish(),
    prospect: z.string().nullish(),
    stage_date: z.string().nullish(),
    sequence: z.number().nullish()
  })
  .strict()

export const PipelineProspectsModelFields = makeFieldKeys(PipelineProspectsModelSchema)

export type PipelineProspectsModel = z.infer<typeof PipelineProspectsModelSchema>

function validatePipelineProspectsModel(data: unknown): PipelineProspectsModel {
  try {
    return validateWithZodSchema(PipelineProspectsModelSchema, data, 'pipeline prospects model')
  } catch (error) {
    throw new Error(`Pipeline prospects model validation failed: ${error}`)
  }
}
